import { NextTable } from '@core/table';

import { CountriesTableContext } from '../contexts';
import { useCountriesTable } from '../hooks';

export const CountriesTable = () => {
  const { columns, getRowProps } = useCountriesTable();

  return <NextTable sortable={false} pagination={false} getRowProps={getRowProps} context={CountriesTableContext} columns={columns} />;
};
